module.exports = __webpack_public_path__ + "static/media/R1.29c0fde5.png";